/** 关前关后banner子节点 */
let Event = require("cocos/framework/components/event");

let MedalRankItem = xClass("MedalRankItem", Event, function () {
    return cc.CSLoader.createNode("cocos/start_rank_player_item.csb");
})

MedalRankItem.prototype.ctor = function () {
    let self = this;
    self.bind(self);
    self.initUI();
}

MedalRankItem.prototype.initUI = function () {
    let self = this;
    self.bg = self.getChildByName("start_rank_player3");
    self.icon_frame = self.getChildByName("head");
    self.num = self.getChildByName("label_num");
    self.name = self.getChildByName("label_name");
    self.rank = self.getChildByName("num");
    self.rankBgNode = self.rank.getChildByName("start_rank_num4");
    self.rankStr = self.rankBgNode.getChildByName("label");

    self.rankStr.ignoreContentAdaptWithSize(true);
    self.num.ignoreContentAdaptWithSize(true);
}

MedalRankItem.prototype.initData = function (data, curTab) {
    let self = this;
    if (data) {
        const uid = UserManager.getInstance().uid;
        const isMe = uid == data.uid;
        //排名
        self.initType(curTab, isMe);
        let rankBgType = data.rank;
        let rankText = rankBgType;
        if (!rankText) {
            rankText = "未上榜";
        }
        if (!rankBgType || rankBgType > 4) {
            rankBgType = 4;
        }
        for (let i = 1; i < 5; i++) {
            const node = self.rank.getChildByName(`start_rank_num${i}`);
            node && node.setVisible(i == rankBgType);
        }
        self.rankStr.setString(rankText);
        let width = 25;
        if (!data.rank || data.rank > 99) {
            width = 56;
        }
        self.rankBgNode.getChildByName("bg1").width = width;
        self.rankBgNode.getChildByName("bg2").width = width;
        self.rankStr.x = (width - 25) / 2;
        self.num.setString(data.value);
        //
        let nickname = data.nickname || "海滨消消乐玩家";
        // let labelid = UIUtils.getIdFromUsershow(data.userShow, "label");
        UIUtils.createNameWithUserShow(self.name, isMe ? "我" : nickname, 90, data.userShow)
        if (data.avatar) {
            HeadImageLoader.loadImage(self.getChildByName("head"), data.avatar);
        } else {
            let str = "https://sff.happyelements.com/cdn/app/1001/avatar/0.png";
            HeadImageLoader.loadImage(self.getChildByName("head"), str);
        }
        //有默认头像框
        DressManager.getInstance().addHeadFrameByUseShow(self.getChildByName("head"), data.userShow, 0.6);

        self.rank.setLocalZOrder(99);

        self.data = data;
        self.curTab = curTab;
    }

}
//通过类型换皮 1-好友 2-勋章全国
MedalRankItem.prototype.initType = function (type, isMe = false) {
    let self = this;
    self.rankBgNode.getChildByName("bg1").setVisible(type == 1);
    self.rankBgNode.getChildByName("bg2").setVisible(type == 2);
    //
    if (isMe) {
        type = 3;
    }
    self.bg.initWithSpriteFrameName("start_rank/start_rank_player" + type + ".png");
}

//添加装扮信息
MedalRankItem.prototype.tryAddUserShow = function (data) {
    let self = this;
    //浅copy
    if (data && self.data && data.nickname) {
        self.initData(data, self.curTab);
    }
}

module.exports = MedalRankItem;
